export const isFeatureFlagEnabled = (optimizelyJSON, featureFlag) =>
{
    const flag = optimizelyJSON?.keyValueMap?.[featureFlag];
    if (!flag || !flag.rollout) 
    {
        return false;
    }

    return flag.rollout.experiments.some((experiment) =>
        experiment.status === 'Running' && experiment.variations.some((variation) => 
            variation.key === 'on' && variation.featureEnabled
        )
    );
}